import { render, staticRenderFns } from "./CurveChart.vue?vue&type=template&id=10ed4a22&scoped=true&"
import script from "./CurveChart.vue?vue&type=script&lang=js&"
export * from "./CurveChart.vue?vue&type=script&lang=js&"
import style0 from "./CurveChart.vue?vue&type=style&index=0&id=10ed4a22&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ed4a22",
  null
  
)

export default component.exports